import { ModernFiltersState } from './index';

export interface EndpointFilters {
	[key: string]: string | number | boolean;
}

export const convertModernFiltersToEndpoint = (filters: ModernFiltersState): EndpointFilters => {
	const endpointFilters: EndpointFilters = {};

	// Solo añadir filtros que tengan valores válidos
	if (filters.vcCode && filters.vcCode.trim() !== '') {
		endpointFilters.vcCode = filters.vcCode.trim();
	}

	if (filters.saleOrderId && filters.saleOrderId.trim() !== '') {
		endpointFilters.saleOrderId = filters.saleOrderId.trim();
	}

	if (filters.saleOrderCreatedBy && filters.saleOrderCreatedBy.trim() !== '') {
		endpointFilters.saleOrderCreatedBy = filters.saleOrderCreatedBy.trim();
	}

	if (filters.saleOrderDealId && filters.saleOrderDealId.trim() !== '') {
		const dealId = parseInt(filters.saleOrderDealId);
		if (!isNaN(dealId)) {
			endpointFilters.saleOrderDealId = dealId;
		}
	}

	if (filters.ticketType && filters.ticketType.trim() !== '') {
		endpointFilters.ticketType = filters.ticketType;
	}

	if (filters.ticketingRequested !== null && filters.ticketingRequested !== undefined) {
		endpointFilters.ticketingRequested = filters.ticketingRequested;
	}

	if (filters.ticketingStatus && filters.ticketingStatus.trim() !== '') {
		endpointFilters.ticketingStatus = filters.ticketingStatus;
	}

	if (filters.saleOrderAgencyId && filters.saleOrderAgencyId.trim() !== '') {
		const agencyId = parseInt(filters.saleOrderAgencyId);
		if (!isNaN(agencyId)) {
			endpointFilters.saleOrderAgencyId = agencyId;
		}
	}

	if (filters.serviceEnable !== null && filters.serviceEnable !== undefined) {
		endpointFilters.serviceEnable = filters.serviceEnable;
	}

	// Para fechas, podríamos necesitar manejarlas de manera especial dependiendo de lo que espere el endpoint
	// Por ahora las incluiremos como están si tienen valores
	if (filters.ticketingLimitDateFrom) {
		endpointFilters.ticketingLimitDateFrom = filters.ticketingLimitDateFrom.toISOString().split('T')[0];
	}

	if (filters.ticketingLimitDateTo) {
		endpointFilters.ticketingLimitDateTo = filters.ticketingLimitDateTo.toISOString().split('T')[0];
	}

	if (filters.serviceCreatedFrom) {
		endpointFilters.serviceCreatedFrom = filters.serviceCreatedFrom.toISOString().split('T')[0];
	}

	if (filters.serviceCreatedTo) {
		endpointFilters.serviceCreatedTo = filters.serviceCreatedTo.toISOString().split('T')[0];
	}

	return endpointFilters;
};

export const getDefaultSort = (): Array<{ field: string; order: 'asc' | 'desc' }> => {
	return [{ field: 'ticketingLimitDatetime', order: 'asc' as const }];
};

export const getDefaultSortConfig = (): { field: string; order: 'asc' | 'desc' } => {
	return { field: 'ticketingLimitDatetime', order: 'asc' as const };
};
